import {lazy} from 'react';
import Bugsnag from '@bugsnag/js';

export const CHUNK_LOAD_RELOAD_KEY = 'coachfirst.chunk-load-reloaded';

export const isChunkLoadError = error => {
  const message = String(error?.message || error || '');
  return (
    error?.name === 'ChunkLoadError' ||
    error?.code === 'CSS_CHUNK_LOAD_FAILED' ||
    /Loading (?:CSS )?chunk [\w-]+ failed/i.test(message) ||
    /ChunkLoadError/i.test(message)
  );
};

export const getChunkLoadDiagnostics = error => ({
  isChunkLoadError: isChunkLoadError(error),
  errorName: error?.name || null,
  errorMessage: String(error?.message || error || ''),
  failureType: error?.type || null,
  chunkUrl: error?.request || null,
  online: navigator.onLine,
  visibilityState: document.visibilityState,
  connectionType: navigator.connection?.effectiveType || null,
});

export const importWithChunkRetry = async load => {
  try {
    return await load();
  } catch (error) {
    if (!isChunkLoadError(error) || navigator.onLine === false) throw error;

    Bugsnag.leaveBreadcrumb('chunk-load-retry-scheduled', {
      ...getChunkLoadDiagnostics(error),
      retryDelayMs: 1000,
    });
    await new Promise(resolve => setTimeout(resolve, 1000));

    if (navigator.onLine === false) throw error;

    // Webpack clears failed chunks from its cache. Retry inside the lazy
    // promise, before React caches a rejection and renders the error boundary.
    const loadedModule = await load();
    Bugsnag.leaveBreadcrumb('chunk-load-retry-succeeded', {
      chunkUrl: error?.request || null,
    });
    return loadedModule;
  }
};

export const lazyWithChunkRetry = load => lazy(() => importWithChunkRetry(load));
